import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function WhyItFailed() {
  const failures = ["Cocinar 'a ver quién quiere' es la receta perfecta para perder dinero y comida.", "No saber cobrar correctamente hace que trabajes 8 horas para ganar solo $10 dólares de 'ganancia' real.", 'Publicar en grupos de Facebook sin un guion claro te hace ver desesperada en lugar de profesional.', 'Intentar menús complicados te agota y no te deja tiempo para cuidar a tus hijos.'];
  return <section className="bg-kitchen-cream py-12 md:py-20 px-5 md:px-12 lg:px-24" data-id="element-195">
      <div className="max-w-4xl mx-auto" data-id="element-196">
        <FadeIn data-id="element-197">
          <h2 className="font-lora text-2xl md:text-4xl font-bold text-kitchen-brown text-center mb-8 md:mb-12" data-id="element-198">
            Por qué lo que intentaste antes{' '}
            <span className="text-kitchen-terracotta border-b-4 border-kitchen-terracotta" data-id="element-199">
              no funcionó
            </span>{' '}
            📉
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-200">
          {failures.map((failure, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-201">
              <div className="bg-white p-4 md:p-6 rounded-xl shadow-sm border border-kitchen-brown/10 flex items-start gap-3 md:gap-4 h-full" data-id="element-202">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-kitchen-terracotta flex-shrink-0 mt-1" data-id="element-203" />
                <p className="font-nunito text-base md:text-lg text-kitchen-brown/90 leading-relaxed" data-id="element-204">
                  {failure}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}